import { render } from "./EditSelf.vue?vue&type=template&id=9c77dbfe"
import script from "./EditSelf.vue?vue&type=script&lang=js"
export * from "./EditSelf.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__